import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'components/Luxkit/Typography/Heading'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import LayoutContainer from 'components/Common/LayoutContainer'

interface Props {
  title?: string;
  description?: string;
  titleTag: any;
}

const Description = styled(Subtitle)`
  margin-bottom: ${rem(35)};
`

function OfferListHeading(props: Props) {
  const { title, description, titleTag } = props
  if (!title && !description) {
    return null
  }
  return (
    <LayoutContainer size="md">
      <Heading variant="heading2" align="center" as={titleTag}>{title}</Heading>
      {description && <Description variant="subtitle2" align="center" forwardedAs="h2">
        {description}
      </Description>}
    </LayoutContainer>
  )
}

OfferListHeading.defaultProps = {
  titleTag: 'h1',
}

export default OfferListHeading
